import { render, staticRenderFns } from "./skuSidebar.vue?vue&type=template&id=08aceeae&scoped=true&"
import script from "./skuSidebar.vue?vue&type=script&lang=ts&"
export * from "./skuSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./skuSidebar.vue?vue&type=style&index=0&id=08aceeae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08aceeae",
  null
  
)

export default component.exports